import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { newsletterAPI } from '../services/api';

function Footer() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState({ text: '', type: '' });
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setMessage({ text: 'Please enter your email', type: 'error' });
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setMessage({ text: 'Invalid email address', type: 'error' });
      return;
    }

    setLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const response = await newsletterAPI.subscribe(email);
      console.log('Newsletter response:', response.data);

      if (response.data.success) {
        setMessage({ text: 'Thank you for subscribing!', type: 'success' });
        setEmail('');
      } else {
        setMessage({ text: response.data.message || 'Error during subscription', type: 'error' });
      }
    } catch (error) {
      console.error('Error:', error);
      if (error.response) {
        setMessage({ text: error.response.data?.message || 'Server error', type: 'error' });
      } else {
        setMessage({ text: 'Error connecting to the server', type: 'error' });
      }
    } finally {
      setLoading(false);
      setTimeout(() => setMessage({ text: '', type: '' }), 5000);
    }
  };

  return (
    <footer>
      <div className="footer-wrapper section-bg2" data-background="/assets/img/gallery/footer_bg.png">
        {/* Footer Top*/}
        <div className="footer-area footer-padding">
          <div className="container">
            <div className="row d-flex justify-content-between">
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                <div className="single-footer-caption mb-50">
                  <div className="footer-tittle footer-brand-block">
                    <Link to="/" style={{ textDecoration: 'none' }}>
                      <h3>EFIS</h3>
                    </Link>
                    <p className="footer-brand-tagline">
                      Europe Foundation for International Solidarity — promoting dialogue, mobility, and global citizenship from Poland.
                    </p>
                    <p className="footer-brand-location">Siedlce, Poland</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <div className="single-footer-caption mb-50">
                  <div className="footer-tittle">
                    <h4>Contact Info</h4>
                    <ul>
                      <li><p>Address: Siedlce, Poland</p></li>
                      <li><Link to="#">WhatsApp: 0048516160255</Link></li>
                      <li><Link to="#">Email: contact.efis2025@gmail.com</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <div className="single-footer-caption mb-50">
                  <div className="footer-tittle">
                    <h4>Important Link</h4>
                    <ul>
                      <li><Link to="/projects">View Activities</Link></li>
                      <li><Link to="/contact">Contact Us</Link></li>
                      <li><Link to="/contact">Become a Volunteer</Link></li>
                      <li><Link to="/programs">Our Programs</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <div className="single-footer-caption mb-50">
                  <div className="footer-tittle">
                    <h4>Newsletter</h4>
                    <div className="footer-pera footer-pera2">
                      <p>Subscribe to get updates about our programs.</p>
                    </div>
                    <div className="footer-form">
                      <form onSubmit={handleSubscribe} className="subscribe_form relative mail_part">
                        <input 
                          type="email" 
                          name="email" 
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Email Address" 
                          disabled={loading}
                          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-purple-500"
                        />
                        <div className="form-icon">
                          <button 
                            type="submit" 
                            name="submit" 
                            className="email_icon newsletter-submit button-contactForm"
                            disabled={loading}
                          >
                            <img src="/assets/img/gallery/form.png" alt="Subscribe" />
                          </button>
                        </div>
                      </form>
                      {message.text && (
                        <div className={`mt-3 text-sm ${message.type === 'success' ? 'text-green-600' : 'text-red-600'}`}>
                          {message.text}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* footer-bottom */}
        <div className="footer-bottom-area">
          <div className="container">
            <div className="footer-border">
              <div className="row d-flex justify-content-between align-items-center">
                <div className="col-xl-10 col-lg-9">
                  <div className="footer-copy-right">
                    <p>Copyright &copy; {new Date().getFullYear()} All rights reserved | EFIS -   Developed By <a href="">Amine Makni</a>

      {/*Europe Foundation for International Solidarity*/}
      </p>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-3">
                  <div className="footer-social f-right">
                    <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                    <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;